import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]',
  standalone: true,
})
export class NumbersOnlyDirective {
  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      8, // Backspace
      9, // Tab (für bessere Navigation)
      13, // Enter (für Formular-Submit)
      16, // Shift (z. B. für Shift+Tab)
      17, // Strg (für Kopieren/Einfügen)
      18, // Alt
      20, // CapsLock
      27, // Escape
      35, // End
      36, // Home
      37, // Pfeil links
      38, // Pfeil oben
      39, // Pfeil rechts
      40, // Pfeil unten
      45, // Insert
      46, // Delete
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57, // Ziffern 0-9 (obere Reihe)
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105, // Numpad 0-9
      //   110, // Numpad Dezimalpunkt (.)
      //   190, // Punkt (.) auf der Tastatur
    ];

    if (allowedKeys.includes(event.keyCode) || (event.ctrlKey && [67, 86, 88].includes(event.keyCode))) {
      // Strg+C, Strg+V, Strg+X
      return; // Erlaube Steuerungs-Tasten
    }

    event.preventDefault(); // Blockiere alle anderen Tasten
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData('text/plain');
    if (pastedText && !/^\d+$/.test(pastedText)) {
      event.preventDefault(); // Blockiere Einfügen von Nicht-Zahlen
    }
  }
}
